export default __webpack_public_path__ + "static/media/ocean-green.d52f475a.svg";